/***************************************************************************
*
* This is used in several files for setting the text color
* based on background color selection
*
***************************************************************************/


// colors.js
export const DARK_BACKGROUND_COLORS = ['#32006e', '#404040'];
export const DEFAULT_TEXT_COLOR = 'black';
export const WHITE_TEXT_COLOR = '#ffffff';
export const DEFAULT_LINK_COLOR = '#32006e';
export const DEFAULT_HEADING_COLOR = '#32006e';

export const colors = [
    { name: 'White', color: '#ffffff' },
    { name: 'Lite Grey', color: '#e5e5e5' },
    { name: 'Dark Grey', color: '#404040' },
    { name: 'Purple', color: '#32006e' },
];
